export const iukStrafrecht = `
# Informations- und Kommunikationstechnik (IuK)-Strafrecht
## <br> Definition
## <br> Typische Fälle
## <br> Versuch
## <br> Datenveränderung
## <br> Computerbetrug
## <br> Abfangen von Daten
## <br> Computersabotage
`;